import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormPage} from '../../models/WebFormTemplate';

@Component({
    selector: 'app-form-faq',
    templateUrl: './form-faq.component.html',
    styleUrls: ['./form-faq.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFaqComponent implements OnInit {

  @Input() formPage: FormPage;

  constructor() { }

  ngOnInit(): void {
  }

}
